/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OwnersControllerCreateMutationRequest, OwnersControllerCreateMutationResponse, OwnersControllerCreate400, OwnersControllerCreate401, OwnersControllerCreate403 } from "../../models/ownersController/OwnersControllerCreate";

function getOwnersControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/owners` as const }  
  return res
}

/**
 * @summary Create a new owner
 * {@link /api/v1/owners}
 */
export async function ownersControllerCreate(data?: OwnersControllerCreateMutationRequest, config: Partial<RequestConfig<OwnersControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<OwnersControllerCreateMutationResponse, ResponseErrorConfig<OwnersControllerCreate400 | OwnersControllerCreate401 | OwnersControllerCreate403>, OwnersControllerCreateMutationRequest>({ method : "POST", url : getOwnersControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}